import { render, staticRenderFns } from "./bulk-revamp-awareness.vue?vue&type=template&id=7dbe07ca&scoped=true&"
import script from "./bulk-revamp-awareness.vue?vue&type=script&lang=js&"
export * from "./bulk-revamp-awareness.vue?vue&type=script&lang=js&"
import style0 from "./bulk-revamp-awareness.vue?vue&type=style&index=0&id=7dbe07ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbe07ca",
  null
  
)

export default component.exports